import { Fragment, ReactNode } from 'react';

import { Column, Label } from 'components/Blocks';
import { UserIcon } from 'components/Icons';
import { cn } from 'styles';
import { toTruthyList } from 'utils/array';

interface Props {
  label: ReactNode;
  value: ReactNode;
  Icon?: typeof UserIcon;
  valueClassName?: string;
}

function parseLineBreak(value: ReactNode) {
  if (typeof value !== 'string') return value;

  return (
    <>
      {toTruthyList(value.split('\n')).map((line, index) => (
        <Fragment key={`${line}-${index}`}>
          {!!index && <div className="mt-1" />}

          {line}
        </Fragment>
      ))}
    </>
  );
}

export function SingleProperty({ label, value, Icon, valueClassName }: Props) {
  return (
    <Column gap="2" fullWidth>
      <Label className="flex items-center gap-2">
        {Icon && <Icon size={14} />}
        {label}
      </Label>

      <div className={cn('rounded-md border p-2 text-sm', valueClassName)}>
        {parseLineBreak(value)}
      </div>
    </Column>
  );
}
